/**
 * 获取cookie
 */
export default function getCookieValue(a) {
    a = document.cookie.match(RegExp(a + '=([^&;]+)'))
    if (a != null )
        return decodeURI(a[1])
    return ''
}